import { render, staticRenderFns } from "./viewClosed.vue?vue&type=template&id=adf82cfc"
import script from "./viewClosed.vue?vue&type=script&lang=js"
export * from "./viewClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports